import React from 'react';

// Photo on top, then eyebrow / title / content.
export default function StackedHero({ image, alt, position = 'center', eyebrow, title, children, testId }) {
  return (
    <section className="pt-8 md:pt-12 pb-12" data-testid={testId}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="rounded-[2rem] overflow-hidden shadow-xl h-[260px] sm:h-[360px] lg:h-[460px]">
          <img src={image} alt={alt} fetchpriority="high" decoding="async" className="w-full h-full object-cover" style={{ objectPosition: position }} />
        </div>
        <div className="mt-10 max-w-3xl">
          <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">{eyebrow}</div>
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-splash-green leading-tight">{title}</h1>
          {children}
        </div>
      </div>
    </section>
  );
}
